import api from "@/router/api"

export default {
    getAllLevels4({commit}, payload){
        return new Promise((resolve, reject) => {
            api.auxiliariesLevel4.list(payload)
            .then(response => {
                resolve(response.data.data)

                commit('SET_LEVELS_4', response.data.data)
            })
            .catch(error => {
                reject({
                    message: 'Ocurrió un problema al obtener los niveles 4',
                })
            })
        })
    },
}
